import http from "./http";
import type { Permiso } from "../models/permiso_model";
import type { ResultadoConPaginacion } from "../types";

type QueryPrimitive = string | number | boolean;

export const listarPermisos = async (
  customQuery: {
    _page?: number;
    _limit?: number;
    estudiante?: string
    desde?: string;
    hasta?: string;
    estado?: string;
    verComoJefeCurso?: boolean;
    kardex?: boolean;
  }
): Promise<ResultadoConPaginacion<Permiso>> => {
  try {
    const filtros: Record<string, QueryPrimitive | undefined> = customQuery;
    const query = Object.keys(filtros)
      .map((key) => `${key}=${filtros[key]}`)
      .join("&");
    return await http.get<ResultadoConPaginacion<Permiso>>(
      `/permiso_v2${query.length > 0 ? `?${query}` : ""}`
    );
  } catch (error) {
    console.error("[get] Error :: ", error);
    return { rows: [], count: 0, limit: 0, page: 0 };
  }
};

export const getPermisos = async (estado?: string, estudiante?: string) => {
  try {
    const filtros: Record<string, QueryPrimitive> = {};
    if (estado) filtros.estado = estado;
    if (estudiante) filtros.estudiante = estudiante;
    const query = Object.keys(filtros)
      .map((key) => `${key}=${filtros[key]}`)
      .join("&");
    return await http.get<Permiso[]>(`/permiso/${query.length > 0 ? `?${query}` : ""}`);
  } catch (error) {
    console.error("[get] Error :: ", error);
    return [];
  }
};

export const getPermisoById = async (id: string) => {
  try {
    return await http.get<Permiso>(`/permiso/${id}`);
  } catch (error) {
    console.error("[get_by_id] error :: ", error);
    return null;
  }
};

export const createPermiso = async (data: Permiso) => {
  try {
    return await http.post<Permiso, Permiso>(`/permiso/`, data);
  } catch (error) {
    console.error("[create] Error :: ", error);
    return null;
  }
};

export const editPermiso = async (data: Permiso, id: string) => {
  try {
    return await http.put<Permiso, Permiso>(`/permiso/${id}`, data);
  } catch (error) {
    console.error("[put] Error :: ", error);
    return null;
  }
};

export const infoPermiso = async (data: Permiso, id: string) => {
  try {
    return await http.put<Permiso, Permiso>(`/permiso/${id}/mas-info`, data);
  } catch (error) {
    console.error("[put] Error :: ", error);
    return null;
  }
};

export const infoAltaMedica = async (data: Permiso, id: string) => {
  try {
    return await http.put<Permiso, Permiso>(`/altaMedica/${id}/mas-info`, data);
  } catch (error) {
    console.error("[put] Error :: ", error);
    return null;
  }
};

export const deletePermiso = async (id: string) => {
  try {
    return await http.delete<Permiso>(`/permiso/${id}`);
  } catch (error) {
    console.error("[delete] Error :: ", error);
    return null;
  }
};

export const aceptarRechazarPermiso = async (data: Permiso, id: string) => {
  try {
    return await http.put<Permiso, Permiso>(`/permiso/${id}/responder`, data);
  } catch (error) {
    console.error("[put] Error :: ", error);
    return null;
  }
};

export const sendEmail = async (id: string) => {
  try {
    return await http.post(`/permiso/${id}/send-mail`, {});
  } catch (error) {
    console.error("[post] Error :: ", error);
    return null;
  }
};

export const buscarCorreo = async (id: string) => {
  try {
    return await http.get(`/permiso/${id}/buscar-correo`, {});
  } catch (error) {
    console.error("[post] Error :: ", error);
    return null;
  }
};
